// Parallele Tonaufnahme zum Live-Diktat (Cockpit-Muster, 23.08.2026).
//
// Das Live-Diktat (lib/dictation.js) schreibt beim Sprechen mit, kennt aber
// keine Fachbegriffe. Darum laeuft parallel eine Tonaufnahme; nach dem Stopp
// hoert lokales Whisper auf dem Server sie AM STUECK nach und die saubere
// Fassung ersetzt den Live-Text ("Nachkorrektur"). Faellt Whisper aus, bleibt
// der Live-Text stehen — schlechter als vorher kann es nicht werden.

export function tapeAvailable() {
  return typeof window !== 'undefined'
    && typeof window.MediaRecorder !== 'undefined'
    && !!navigator.mediaDevices?.getUserMedia
}

function pickType() {
  if (!window.MediaRecorder?.isTypeSupported) return ''
  const TYPES = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus']
  return TYPES.find((t) => window.MediaRecorder.isTypeSupported(t)) || ''
}

// Startet die Tonaufnahme. Wirft, wenn das Mikrofon nicht zu haben ist — der
// Aufrufer diktiert dann einfach ohne Nachkorrektur weiter.
export async function startTape() {
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: { channelCount: 1, echoCancellation: true, noiseSuppression: true }
  })
  const mimeType = pickType()
  const rec = new MediaRecorder(stream, mimeType ? { mimeType, audioBitsPerSecond: 32000 } : undefined)
  const chunks = []
  rec.ondataavailable = (e) => { if (e.data?.size) chunks.push(e.data) }
  rec.start()
  const release = () => stream.getTracks().forEach((t) => { try { t.stop() } catch { /* egal */ } })
  return {
    // Liefert { blob, mimeType } oder null, wenn nichts Verwertbares da ist.
    stop() {
      return new Promise((resolve) => {
        const type = rec.mimeType || mimeType || 'audio/webm'
        if (rec.state === 'inactive') { release(); resolve(null); return }
        let done = false
        const finish = (blob) => { if (done) return; done = true; release(); resolve(blob) }
        rec.onstop = () => finish(chunks.length ? { blob: new Blob(chunks, { type }), mimeType: type } : null)
        // Notausgang: Bleibt onstop aus (MediaRecorder-Fehler), hinge dieses
        // Promise ewig — und mit ihm das Mikrofon.
        setTimeout(() => finish(null), 5000)
        try { rec.stop() } catch { finish(null) }
      })
    },
    // Wegwerfen (Abbruch/Unmount): Mikro freigeben, kein Ergebnis.
    cancel() {
      try { if (rec.state !== 'inactive') rec.stop() } catch { /* egal */ }
      release()
    }
  }
}

// Blob → base64 (der /api/agent/voice-Endpunkt erwartet base64 im JSON-Body).
export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result.split(',')[1])
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}
